import React from 'react'
import POItemHeader from './POItemHeader'
import POItemInner from './POItemInner'
import POItemFooter from './POItemFooter'
import { savePO, deletePO } from '../PurchaseOrderFunctions'

export const poItemControllerContext = React.createContext()

function usePOItemController(props) {
  const poItem = props.poItem

  const obj = {
    poItem,
    savePO,
    deletePO,
  }

  return (obj)
}

function POItemController(props) {
  const poItemController = usePOItemController(props)
  return (
    <React.Fragment>
      <poItemControllerContext.Provider value={poItemController}>
        <POItemHeader />
        <POItemInner />
        <POItemFooter />
      </poItemControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(POItemController)